import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

const vuetify = new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#DA346C',
                secondary: '#003E4B',
                accent: '#DA346C',
                anchor: '#FFED00',
                error: '#DA346C',
                yellow: '#FFED00'
            },
        },
    },
})

export default vuetify
